import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import type { AttachmentKind } from '../../client'

const MEDIA = 'max-h-[85vh] max-w-full rounded-xl shadow-2xl'

type Props = {
  src: string | null
  alt?: string
  kind?: AttachmentKind
  onClose: () => void
}

export default function MediaPreview({ src, alt = '', kind = 'image', onClose }: Props) {
  return (
    <Dialog open={Boolean(src)} onClose={onClose} className="relative z-[220]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-stone-900/80 transition duration-150 data-closed:opacity-0"
      />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className="relative transition duration-150 data-closed:scale-95 data-closed:opacity-0"
        >
          {src && kind === 'image' && <img src={src} alt={alt} className={`${MEDIA} object-contain`} />}
          {src && kind === 'video' && <video src={src} controls autoPlay className={MEDIA} />}
          {src && kind === 'audio' && (
            <div className="rounded-xl bg-white p-3 pr-12 shadow-2xl">
              <audio src={src} controls autoPlay />
            </div>
          )}
          <button
            type="button"
            aria-label="Close preview"
            onClick={onClose}
            className="absolute top-2 right-2 flex size-7 items-center justify-center rounded-full bg-stone-900 text-white"
          >
            <XMarkIcon className="size-4" strokeWidth={2.4} />
          </button>
        </DialogPanel>
      </div>
    </Dialog>
  )
}
